import Minutes from './MinutesRequirementItem/MinutesRequirementItem';
import PersonalInfo from './PersonalInfoRequirementItem/PersonalInfoRequirementItem';
import Usage from './UsageRequirementItem/UsageRequirementItem';

export default {
  Minutes,
  PersonalInfo,
  Usage,
};
